import { CSSObject } from '@chakra-ui/react';

export const WrapperContent: CSSObject = {
  display: 'flex',
  flexDir: 'column',
  py: ['4', null, '10'],
  px: ['2', null, '10'],
  flex: [null, null, 1],
  justifyContent: [null, null, 'center'],
  minW: ['unset', null, '460px'],
  bg: 'alpha.500',
  borderRightRadius: ['unset', null, 'lg'],
  form: {
    '.chakra-form-control': {
      '.chakra-form__label': {
        color: 'white',
        fontSize: 'xs',
      },
    },
    'a[href*="forgot-password"]': {
      color: 'beta.500',
      fontWeight: 'bold',
      fontSize: 'xs',
    },
    '.chakra-button[data-cy*="loginSubmit"]': {
      textShadow: '0px 0px 8px rgba(67, 187, 255, 0.50)',
    },
    'button[aria-label*="password toggle"]': {
      top: '-1px',
      color: 'beta.500',
    },
    'input:-webkit-autofill, input:-webkit-autofill:focus': {
      transition: 'background-color 0s 600000s, color 0s 600000s',
    },
  },
};

export const Title: CSSObject = {
  color: 'white',
  fontSize: 'md',
  fontFamily: 'accent',
  fontStyle: 'normal',
  fontWeight: 'normal',
  mb: '4',
  mt: [null, null, '9'],
};
